export const ACTIVE_DUTY_MAPS = [
  'de_inferno',
  'de_mirage',
  'de_nuke',
  'de_dust2',
  'de_vertigo',
  'de_ancient',
  'de_anubis',
  'de_train',
  'de_cache',
  'de_overpass',
];
